import { instance as axios, setJwtToken, setMultiPartHeader } from "../../config/axiosInstance"


// --------------------get-single-subscription------------------------
export const fathSubscriptionListApi = async () => {
    const endPoint = `/plan/list`
    return await axios.get(endPoint, setJwtToken())
}

// --------------------get-single-subscription------------------------
export const fathSubscriptionApi = async (data) => {
    const endPoint = `/plan` + `?` + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken())
}

// ---------------------update-subscription--------------------------
export const updatePlanApi = async (data) => {
    const endPoint = `/plan/update`
    return await axios.post(endPoint, data, setJwtToken())
}